.folderTypeContainer { 
    display: flex;
    align-items: flex-end;
}

.folderTypeName {
    width: 50%;
}